<template>
  <el-dialog title="支付宝收款账号维护" :visible.sync="dialogVisible" :before-close="closeDialog"
    append-to-body width="600px" :close-on-click-modal="false" v-loading="loadingFlag">
    <div class="content">
      <!--  -->
       <div class="tip-box"><img class="icon-24-warning" src="@/assets/images/icon/warning_icon.png" alt="">请确认实名信息</div>
      <div>
        <div class="content-txt">为保障返佣金额正常打款，请维护当前客户管家登录账号的实名信息对应的支付宝实名账号。</div>
        <div class="content-txt y-mt-10">当前账号实名信息：</div>
        <div class="real-name-box y-mt-10" v-if="realNameId">
          <span class="realname">{{ isRealNameInfo.cerName }}</span>
          <!-- <el-popover
            placement="right"
            width="400"
            trigger="click">
            <div class="real-popover-box">
              <div class="real-popover-title">查看实名</div>
              <div class="y-pb-15">
                <div class="tip-txt"><img class="icon-tip" src="@/assets/images/icon/warning_icon.png" alt="">当前实名信息为维护支付宝账号的客户管家账号实名信息</div>
                <div class="real-name-content">
                  <div >
                    <span class="real-name-label">姓名 :</span> <span class="span-text">{{ isRealNameInfo.cerName }}</span>
                  </div>
                  <div class="margin-top-8">
                    <span class="real-name-label">证件类型 :</span> <span class="span-text">{{ isRealNameInfo.cerTypeName }}</span>
                  </div>
                  <div class="margin-top-8">
                    <span class="real-name-label">证件号码 :</span> <span class="span-text">{{ isRealNameInfo.cerNo }}</span>
                  </div> 
                </div>
                               
              </div>
            </div>
            <span slot="reference" class="systemColor y-c-p look-content">查看实名</span>
          </el-popover>           -->
         <span class="systemColor y-c-p look-content" @click="openRealNameFn">查看实名</span>
        </div>
        <div class="no-real-name-box y-mt-10" v-if="!realNameId">
          <span class="realname">未实名</span>
        </div>        
      </div>      
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="goOpenAliDialog" v-if="realNameId">实名正确，去绑定支付宝账号</el-button>
      <el-button type="primary" @click="openRealNameFn" v-if="!realNameId">立即实名</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { searchRealNameInfoApi } from '@/api/waybillPrint/returnPickupPrint'
import {  getCertInfoApi } from '@/api/systemModule/accountSetting/info'
export default {
  name: "record-list",
  props: {
    realNameId:String,
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loadingFlag:true,
      isRealNameInfo:{},
      dialogVisible: this.isShow,
    };
  },
  watch:{

  },
  methods: {
    openRealNameFn(){
      //打开去实名的弹框
      this.$emit("openRealNameDialog",this.isRealNameInfo);
    },
    // 获取实名认证信息
    getCertInfo(type) {
        this.certInfo = {};
        getCertInfoApi().then(res => {
            if (res.data.status == 1) {
              this.isRealNameInfo = res.data.data || {};
                //展示充值或者提现弹
            } else {
                // this.$message.error(res.data.message || '获取实名信息失败');
                //获取实名信息错误的情况下，默认不显示实名认证信息
            }
        }).catch(() => {
            //获取实名信息错误的情况下，默认不显示实名认证信息

        }).finally(() => {

          this.loadingFlag = false;

        })
    },    
    initData(realNameId,type){
      this.getCertInfo(realNameId,type);

      // if(type=='getCertInfo'){
      //   this.getCertInfo(realNameId,type);
      // }else{
      //   this.searchRealNameInfoFn();
      // }
     
    },
    searchRealNameInfoFn(){
      searchRealNameInfoApi({}).then(res=>{
        if(res.message=='ok'&&res.data){
          this.isRealNameInfo = res.data;
        }
        
      }).finally(() => {

          this.loadingFlag = false;

        })
    },
    goOpenAliDialog(){
      this.$emit("goOpenAliDialog");
    },
    // 更具实名ID查询实名信息
    closeDialog(refresh) {
      this.dialogVisible = false;
      this.$emit("closeDialog", refresh);
    },

  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
.big-title {
  letter-spacing: 1px;
  padding-left: 10px;
  font-weight: 800;
  font-size: 14px;
  color: #333333;
}

.big-title::before {
  content: " ";
  position: absolute;
  left: 0px;
  top: 2px;
  width: 2px;
  height: 12px;
  background: #653EB3;
}

.span-text {
  letter-spacing: 1px;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  color: #151719;
}

.span-text1 {
  letter-spacing: 1px;
  font-weight: 400;
  font-size: 12px;
  color: #222222;
}

.content {
  width: 100%;
}

.big-img {
  width: 100%;

  .img {
    width: 100%;
  }
}

.change-account {
  display: inline-block;

  img {
    vertical-align: middle;
    width: 16px;
  }
}

.padding-left9 {
  padding-left: 9px;
}

.content-detail {
  padding-top: 24px;
  margin-top: 24px;
  border-top: 1px solid #EDEDED;
  ;
}
/deep/ .el-dialog__footer {
  text-align: right;
  border-top: 1px solid #EDEDED;
}
/deep/ .el-cascader.el-cascader--small {
  width: 100%;
}

/deep/ .el-dialog__footer {
  text-align: right;
}
.tip-box{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  font-weight: 600;
  font-size: 16px;
  color: #151719;  
}
.icon-24-warning{
  width: 24px;
  height: 24px;
  margin-right: 8px;  
}
.content-txt{
  font-weight: 400;
  font-size: 16px;
  color: #151719;  
}
.real-name-box{
  height: 52px;
  background: #F2F3F4;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;  
  .realname{
    font-weight: 500;
    font-size: 14px;
    color: #151719;
    padding-left: 17px;
  }
  .look-content{
    margin-right: 17px;    
  }
}
.no-real-name-box{
  height: 52px;
  background: rgba(255, 77, 79, 0.06);
  border-radius: 4px;
  display: flex;
  align-items: center;
  .realname{
    font-weight: 500;
    font-size: 14px;
    color: #FF4D4F;
  }
}
.real-popover-box{
  .real-popover-title{
    font-weight: 500;
    font-size: 16px;
    color: #151719;
    text-align: center;
    box-shadow: inset 0px -1px 0px 0px #D7DBDF;    
    padding-bottom: 11px;
  }
  .icon-tip{
    width: 16px;
    height: 16px;
    margin-right: 5px;
  }
  .tip-txt{
    font-weight: 400;
    font-size: 14px;
    color: #FF4D4F;
    display: flex;
    align-items: center;
    padding: 16px 0;

  }
  .real-name-content{
    height: 76px;
    padding: 12px;
    background: #F2F3F4;
    border-radius: 4px;    
  }
  .real-name-label{
    font-size: 14px;
    color: #52585F;
    line-height: 20px;
    display: inline-block;
    text-align: right;
    width: 80px;
  }
  .margin-top-8{
    margin-top: 8px;    
  }
}

</style>